import { endpoints, chatAISimulationHost } from '@config/endpoints';
import request from './request';
import { CancelToken } from 'axios';

export const generateScenario = async (runId: string, cancelToken: CancelToken | null = null) => {
    const { path, method } = endpoints.chatAISimulation.generateScenario;

    let err = null;
    let res: any = null;
    let options = {};
    if (cancelToken)
        options = { cancelToken: cancelToken };

    try {
        ({ data: res } = await request(
            `${chatAISimulationHost}${path}?run_id=${runId}&name=simulation_prompt`,
            method,
            {},
            options,
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
